import { createContext } from 'react';

export interface IDrawerContext {
  open(): void;
  close(): void;
}

export const DrawerContext = createContext<IDrawerContext>(null);
